import { FC, useEffect, useRef } from "react"

import Button from "../generic/buttons/Button"

interface IProps {
  ctaText: string
  cancelText?: string
  hideCancel?: boolean
  onToggle: () => void
  onCallback?: () => void
  isOpen?: boolean
}

const ModalFooter: FC<IProps> = ({
  ctaText,
  cancelText = "Cancel",
  hideCancel = false,
  onToggle,
  onCallback,
  isOpen
}) => {
  const refModal = useRef(null)
  useEffect(() => {
    if (isOpen) {
      refModal.current.focus()
    }
  }, [isOpen])
  return (
    <footer className="modal-footer">
      <div className="d-flex justify-content-end mq-flex-direction-row">
        {!hideCancel && (
          <div className="btn-margin">
            <button
              className="ocs-btn mq-btn-height"
              onClick={onToggle}
              autoFocus
              ref={refModal}
            >
              <span className="ocs-btn-no-icon">{cancelText}</span>
            </button>
          </div>
        )}

        <Button
          onClick={onCallback}
          variant="primary"
          className="mq-btn-height"
        >
          {ctaText}
        </Button>
      </div>
    </footer>
  )
}

export default ModalFooter
